const { isArray } = require("lodash");
const JSConstants = require('_core_ext/constants');
const container = document.querySelector(JSConstants.CLASS_IMAGE_UPLOADER_CONTAINER);
const popUp = document.querySelector(JSConstants.CLASS_DELETE_IMAGE_POPUP);

function imagePlugin(selectedImages, selector, options) {
    const input = document.querySelector(selector);

    if (options.accept && isArray(options.accept)) {
        input.setAttribute('accept', options.accept.join(','));
    }

    const addNewImgBtn = document.createElement('button');
    addNewImgBtn.classList.add('uploud-btn');
    addNewImgBtn.innerHTML  = `<span class="uploud-btn_plus"></span> <span class="uploud-btn_text">add images</span>`;

    container.appendChild(addNewImgBtn);

    addNewImgBtn.addEventListener('click', (event) => {
        event.preventDefault();
        input.click();
    });

    input.addEventListener('change', () => {

        if (!event.target.files.length) {
            return;
        }

        const images = Array.from(event.target.files);

        images.forEach(image => {
            if (!image.type.match('image')) {
                return;
            }
            const reader = new FileReader();

            reader.onload = event => {
                selectedImages.push({
                    file: event.target.result,
                    image: image
                });

                showSelectedImages(selectedImages);
            };

            reader.readAsDataURL(image);
        });
    });

    function addCard (cardClass, image) {
        const card = document.createElement('div');
        card.classList.add(cardClass);
        if (image) {
            card.innerHTML = `
            <img class="card-image" src="${image.file}"/>
            <button class="delete-btn" data-img-name = "${image.image.name}"></button>`;
        } else {
            card.classList.add("image-uploader_button");
            card.appendChild(addNewImgBtn);
        }
        container.appendChild(card);
    }

    function showSelectedImages (selectedImages) {
        container.innerHTML = '';
        selectedImages.forEach(image => {
            addCard('image-uploader_card', image);
        });
        if (selectedImages.length < 4) {
            addCard('image-uploader_card');
        }
    }

    container.addEventListener('click', () => {
        var currentCard = event.target.getAttribute('data-img-name');
        if (currentCard) {
            selectedImages.forEach((item, i, array) => {
                if (item.image.name === currentCard) {
                    array.splice(i, 1);
                }
            });

            showDeletePopUp();

            if (selectedImages.length) {
                showSelectedImages (selectedImages);
            } else {
                container.innerHTML = '';
                container.appendChild(addNewImgBtn);
            }
        }
    });

    function showDeletePopUp() {
        popUp.classList.toggle("hidden");
        setTimeout(function() {
            popUp.classList.toggle("hidden");
        }, 800);
    }
}

exports.init = function (selectedImages, selector, options) {
    imagePlugin(selectedImages, selector, options);
};
